import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from "react-redux";
import featureAction from "../../../redux/feature/actions";
import {parseDataByCategory, parseDataByObjectKey} from "utils/common";
import Menu from "./Menu/Menu";
import './PalletColours.css';
import PaletListMd from "../../../components/PaletListCategory/PaletListMd/PaletListMd"

function PalletColours() {
  const dispatch = useDispatch();
  const userColours = useSelector((state) => state.Feature.userColours);
  const paletNames = Object.keys(userColours);
  const coloursOnCanvas = useSelector((state) => state.Feature.coloursOnCanvas);
  const [selectedPalet, setSelectedPalet] = useState("");

  useEffect(()=>{
    if(paletNames.length > 0 && !selectedPalet){
      setSelectedPalet(paletNames[0]);
    }
  }, [userColours, selectedPalet]);



  const handleSelectedPaletChange = (event) => {
    setSelectedPalet(event.target.value);
  }

  const addColourOnCanvas = (data) => {
    if(coloursOnCanvas.length < 4) {
/*      dispatch(statusAction.addClayOnCanvas(data));*/
      dispatch(featureAction.addColourOnCanvas(data));
    }
  }

  return (
    <div className='acp-toolbar-pallet-color-container'>
      <Menu/>

      <div style={{paddingBottom: '10px'}}>
        <select className='acp-pallet-select' onChange={handleSelectedPaletChange} value={selectedPalet}>
          {
            paletNames.map(key => (
              <option key={key} value={key}>{key}</option>
            ))
          }
        </select>
      </div>
      <div className='acp-colours m-top' >
        {
          selectedPalet &&
          Object.entries(parseDataByObjectKey(userColours[selectedPalet], 'product_name')).map(([key, data], index) => (
            <PaletListMd key={index} category={key} data={data} onClickHandle={addColourOnCanvas} />
          ))
        }
      </div>
    </div>
  );
}

export default PalletColours;